/*
 * action types
 */

export const GROWLER__SHOW = 'GROWLER__SHOW';
export const GROWLER__HIDE = 'GROWLER__HIDE';
export const GROWLER__HIDED = 'GROWLER__HIDED';



/** WEBPACK FOOTER **
 ** ./~/flash-notification-react-redux/src/actions/types/growler.types.js
 **/